import { render, staticRenderFns } from "./NovaTable.vue?vue&type=template&id=4022b92d&scoped=true&lang=pug&"
import script from "./NovaTable.vue?vue&type=script&lang=js&"
export * from "./NovaTable.vue?vue&type=script&lang=js&"
import style0 from "./NovaTable.vue?vue&type=style&index=0&id=4022b92d&prod&lang=scss&scoped=true&"
import style1 from "./NovaTable.vue?vue&type=style&index=1&id=4022b92d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022b92d",
  null
  
)

export default component.exports